import { pricingFormValidation } from '../configuration/PricingValidation';

export const planFormValidation = values => {
  const errors = {
  };

  const isGreaterThanOrEquals = (value, greaterThan) => value >= greaterThan;
  const isLessThan = (value, lessThan) => value < lessThan;
  const maxAmount = Number.MAX_SAFE_INTEGER;
  
  if (!values.name) errors.name = 'Pole jest wymagane';
  if (values.price === null || values.price === undefined || values.price === '') errors.price = 'Pole jest wymagane';

  if (values.price !== null && values.price !== undefined && values.price !== '' && !isGreaterThanOrEquals(Number(values.price), 0)) errors.price = 'Wartość musi być większa lub równa 0';
  if (values.price !== null && values.price !== undefined && values.price !== '' && !isLessThan(Number(values.price), maxAmount)) errors.price = `Wartość musi być mniejsza od ${maxAmount}`;
  if (!values.validity) errors.validity = 'Pole jest wymagane';

  errors.pricingConfiguration = values.voucherOnly
    ? pricingFormValidation({
      ...(values.pricingConfiguration || {}),
      priceList: (values.pricingConfiguration && values.pricingConfiguration.priceList && values.pricingConfiguration.priceList.length)
        ? values.pricingConfiguration.priceList
        : [{ upTo: null, fee: { type: 'free' } }],
    })
    : pricingFormValidation(values.pricingConfiguration || {});

  if (values.voucherOnly) {
    if (Number(values.price) !== 0) errors.price = 'Plan voucherowy musi mieć cenę 0';
    if (values.validity !== 'twentyFourHours') errors.validity = 'Plan voucherowy musi mieć ważność 24 godziny';

    if (!values.pricingConfiguration || !isGreaterThanOrEquals(Number(values.pricingConfiguration.freeMinutesPerPeriod), 1)) {
      errors.pricingConfiguration.freeMinutesPerPeriod = 'Plan voucherowy musi mieć darmowe minuty w okresie rozliczeniowym';
    }
  }
  
  return errors;
};
